export default {
  placeholder: 'Select customer',
};
